export default __webpack_public_path__ + "static/media/O-096.c5f3fe3e.png";